<template>
	<div class="setting_ps px-7 py-4">
		<v-row no-gutters v-if="localUser">
			<v-col cols="12">
				<AvatarSelector :user="localUser" @onFileSelected="onFileSelected" />
			</v-col>
			<v-col cols="12 mt-4">
				<h5 class="my-1">First Name</h5>
				<AppSecondaryTextField v-model="localUser.first_name"></AppSecondaryTextField>
			</v-col>
			<v-col cols="12 mt-4">
				<h5 class="my-1">Last Name</h5>
				<AppSecondaryTextField v-model="localUser.last_name"></AppSecondaryTextField>
			</v-col>
			<v-col cols="12 my-4">
				<h5 class="my-1">Email</h5>
				<AppSecondaryTextField disabled v-model="localUser.email"></AppSecondaryTextField>
			</v-col>
			<v-col cols="12">
				<h5 class="my-1">Timezone</h5>
				<SelectTimezone :userTimezone.sync="userTimezone" />
			</v-col>
		</v-row>
		<div class="text-right">
			<SecondaryButton @click="saveProfile" :loading="loading">Save</SecondaryButton>
		</div>
		<SecondaryButton @click="changePassword">Change Password</SecondaryButton>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment-timezone';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import AvatarSelector from '@/components/Settings/AvatarSelector';
import SelectTimezone from '@/components/SelectTimezone.vue';
export default {
	name: 'SettingsTabsMySettings',
	components: { AvatarSelector, SelectTimezone },
	props: {},
	computed: {
		...mapGetters(['user']),
		timezonesArr() {
			return moment.tz.names();
		},
		userTimezone: {
			set(value) {
				this.localUser.profile.timezone = value;
			},
			get() {
				return this.localUser.profile.timezone;
			},
		},
	},
	methods: {
		...mapActions(['saveUserProfile', 'saveUserProfileAvatar']),
		async saveProfile() {
			this.loading = true;
			try {
				await this.saveUserProfile(this.localUser);
				this.$toast.success('User saved.');
			} finally {
				this.loading = false;
			}
		},
		copyUser() {
			if (this.user) {
				this.$set(this, 'localUser', this.user);
			}
		},
		changePassword() {
			AppDialogManagerService.openChangePasswordDialog();
		},
		async onFileSelected(file) {
			try {
				await this.saveUserProfileAvatar({ avatar: file });
				this.$toast.success(`Avatar ${file ? 'uploaded' : 'removed'}`);
			} catch (err) {
				this.$toast.error('Failed to upload avatar');
			}
		},
	},
	mounted() {
		this.copyUser();
	},
	watch: {
		user: {
			handler() {
				this.copyUser();
			},
		},
	},
	data: () => ({
		loading: false,
		localUser: null,
	}),
};
</script>

<style scoped>
h5 {
	color: #354052 !important;
	font-weight: 600 !important;
}
</style>
